import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCNeF--bRoeTsfeAyrgdCbJjnXSAXrCLN0",
  authDomain: "clone-c96be.firebaseapp.com",
  projectId: "clone-c96be",
  storageBucket: "clone-c96be.appspot.com",
  messagingSenderId: "248519391793",
  appId: "1:248519391793:web:2045a50e5ecb7e9587b310",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db=firebaseApp.firestore();
const auth=firebase.auth();
const provider=new firebase.auth.GoogleAuthProvider();
export {db,auth,provider}